var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPercentRise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.332 2.55523C12.7174 2.55523 12.2209 2.0587 12.2209 1.44412C12.2209 0.829536 12.7174 0.333008 13.332 0.333008H18.8876C19.5022 0.333008 19.9987 0.829536 19.9987 1.44412V6.99967C19.9987 7.61426 19.5022 8.11079 18.8876 8.11079C18.273 8.11079 17.7765 7.61426 17.7765 6.99967V4.12815L11.8945 10.0066C11.4605 10.4406 10.7556 10.4406 10.3216 10.0066L6.66536 6.35037L1.89453 11.1177C1.4605 11.5518 0.755642 11.5518 0.321615 11.1177C-0.112413 10.6837 -0.112413 9.97884 0.321615 9.54481L5.87717 3.98926C6.3112 3.55523 7.01606 3.55523 7.45009 3.98926L11.1098 7.64898L16.2036 2.55523H13.332Z",
    fill: "#97B644"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentRise);
export default __webpack_public_path__ + "static/media/percent-rise.67973b80c26e4666951a21133df4f20e.svg";
export { ForwardRef as ReactComponent };